import Carousel from '../../04-components/carousel';
import 'slick-carousel';

const config = {
	arrows: true,
	dots: false,
	infinite: false,
	variableWidth: true
}

class MenuCarousel extends Carousel {

	constructor(el, options) {
		super(el, options);
	}

	_setup() {

		$(this.carousel).slick(config);
    }
}

export { MenuCarousel as MenuCarousel };